import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ICON } from '@core/util/icon';
import { BusinessChecklistVM, ChecklistItem } from '@models/checklist';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { HttpHandlerService } from '@services/httpHandler/httpHandler.service';
import { NavigationService } from '@services/nav/nav.service';
import { BusinessChecklistsSelectors } from '@state/business/checklists';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { UserProfileState } from '@state/user-profile';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { LeapDispatch } from 'src/app/public/leap/state/leap.dispatch';
import { TestHooks } from './matter-checklist-empty-state.hooks';

@UntilDestroy()
@Component({
	selector: 'app-matter-checklist-empty-state',
	templateUrl: './matter-checklist-empty-state.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class MatterChecklistEmptyStateComponent {
	testHooks = TestHooks;
	public ICON = ICON;
	@ViewSelectSnapshot(UserProfileState.getCurrentBusinessId) businessId: string;
	@ViewSelectSnapshot(SelectedMatter.id) matterId: string;
	@Select(BusinessChecklistsSelectors.getChecklistsByFileType)
	businessChecklists$: Observable<BusinessChecklistVM[]>;
	@Select(BusinessChecklistsSelectors.getItemsByTemplateId)
	tasksFilterFn$: Observable<(id: string) => ChecklistItem[]>;

	constructor(
		private http: HttpHandlerService,
		private navigationService: NavigationService,
		private leapDispatch: LeapDispatch,
	) {}

	selectChecklist(checklist: BusinessChecklistVM): void {
		this.tasksFilterFn$
			.pipe(
				untilDestroyed(this),
				map((filterFn) => filterFn(checklist.id)),
				take(1),
				switchMap((items) => {
					const addChecklistPath = `checklist/matters/${this.matterId}/matterChecklistItems/add`;
					const body: { checklistItems: ChecklistItem[] } = {
						checklistItems: items.map((item) => ({
							...item,
							matterId: this.matterId,
						})),
					};

					return this.http.post(addChecklistPath, body);
				}),
			)
			.subscribe(
				// eslint-disable-next-line @typescript-eslint/no-empty-function
				() => {},
				(error) => {
					// Handle error here
					console.error(error);
				},
			);
	}

	goToSettings() {
		this.navigationService.goToBusinessChecklist();
	}
}
